import {createSlice} from "@reduxjs/toolkit";

/**
 * Режим темы: 'light' | 'dark' | 'system'.
 * Разрешённое значение ('light'/'dark') вычисляет ThemeProvider.
 */
const initialState = {
    mode: "system"
};

export const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        setThemeMode: (state, action) => {
            state.mode = action.payload;
        }
    }
});

export const themeReducer = themeSlice.reducer;
export const {setThemeMode} = themeSlice.actions;

export const selectThemeMode = (state) => state.theme?.mode ?? "system";
